import React from 'react';
import "./ManualParallax.css";
export function ManualParallax() {
  return (
    <div>
      <div className='bgimg-1'>
        <div className='caption'>
          <span className='border'>- CAIOCSA.COM -</span>
        </div>
      </div>

      <div className='section'>
        <h3 className='border'>  </h3>
        <p>
        


        </p>
      </div>

      <div className='bgimg-2'>
        <div className='caption'>
          <span className='border'>CAIOCSA.COM</span>
        </div>
      </div>

     
      <div className='section'>
        <h3 className='border'>   </h3>
        <p>
        
        
        
        </p>
      </div>
    
      <div className='bgimg-3'>
        <div className='caption'>
         {/* <span className='border'></span> */}
        </div>
      </div>

      
    </div>

    )
}
